import { servicesData } from "@/mocks/landingData";

export default function Services() {
  return (
    <section className="section-padding relative">
      <div className="container-main">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <span className="v2-section-label">
              <span className="w-8 h-px bg-teal-400" />
              الخدمات المرتبطة
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4">
              <span className="title-line-1">حلول متكاملة</span>
              <span className="title-line-2 v2-gradient-text">لموقعك</span>
            </h2>
          </div>
          <p className="text-slate-400 max-w-md text-sm md:text-base leading-relaxed">
            من صفحات الهبوط إلى المتاجر الإلكترونية — نقدم حزمة خدمات متكاملة
            تحقق أهدافك الرقمية.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {servicesData.map((service, index) => (
            <article
              key={service.title}
              className="group relative v2-glass-card-hover p-8 overflow-hidden"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-l from-teal-500 to-cyan-400 scale-x-0 group-hover:scale-x-100 transition-transform origin-right duration-500" />
              <div className="w-14 h-14 rounded-2xl bg-teal-500/10 border border-teal-400/20 flex items-center justify-center mb-6 group-hover:bg-teal-500/20 transition-colors">
                <i className={`${service.icon} text-teal-400 text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
